import React from 'react';
import '../../styles/ekyb.css';

const StepRegistryData = ({ entityData, onContinue }) => {
  if (!entityData) {
    return (
      <div className="ekyb-step-container">
        <div className="ekyb-loading">
          <div className="ekyb-spinner"></div>
          <span style={{ marginLeft: '12px' }}>Loading entity data...</span>
        </div>
      </div>
    );
  }

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    } catch {
      return dateString;
    }
  };

  const getStatusBadgeClass = (status) => {
    if (!status) return 'inactive';
    const statusLower = status.toLowerCase();
    if (statusLower.includes('active') || statusLower.includes('registered')) {
      return 'active';
    }
    return 'inactive';
  };

  const formatAddress = (address) => {
    if (!address) return 'N/A';
    if (typeof address === 'string') return address;
    if (typeof address === 'object') {
      const parts = [
        address.street,
        address.postalCode,
        address.city,
        address.country
      ].filter(Boolean);
      return parts.join(', ') || 'N/A';
    }
    return 'N/A';
  };

  return (
    <div className="ekyb-step-container">
      <div className="ekyb-step-header">
        <h2 className="ekyb-step-title">{entityData.name || 'Company Name'}</h2>
        <div style={{ marginTop: '8px' }}>
          <span className={`ekyb-status-badge ${getStatusBadgeClass(entityData.status)}`}>
            {entityData.status || 'ACTIVE'}
          </span>
        </div>
      </div>

      <table className="ekyb-data-table">
        <tbody>
          <tr>
            <td>Company ID</td>
            <td>{entityData.registrationNumber || entityData.companyId || entityData.businessId || 'N/A'}</td>
          </tr>
          <tr>
            <td>Legal Name</td>
            <td>{entityData.name || 'N/A'}</td>
          </tr>
          <tr>
            <td>Registration Date</td>
            <td>{formatDate(entityData.registrationDate)}</td>
          </tr>
          <tr>
            <td>Legal Form</td>
            <td>{entityData.legalForm || entityData.companyForm || 'N/A'}</td>
          </tr>
          <tr>
            <td>Status</td>
            <td>{entityData.status || 'N/A'}</td>
          </tr>
          <tr>
            <td>Registered Address</td>
            <td>{formatAddress(entityData.address)}</td>
          </tr>
          {entityData.registeredOffice && (
            <tr>
              <td>Registered Office</td>
              <td>{entityData.registeredOffice}</td>
            </tr>
          )}
          {entityData.industry && (
            <tr>
              <td>Industry</td>
              <td>{entityData.industry}</td>
            </tr>
          )}
          {entityData.businessLines && entityData.businessLines.length > 0 && (
            <tr>
              <td>Business Activities</td>
              <td>
                {entityData.businessLines.map((line, idx) => (
                  <div key={idx}>{line.description} ({line.code})</div>
                ))}
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <div className="ekyb-button-group">
        <button
          className="ekyb-button ekyb-button-primary"
          onClick={onContinue}
        >
          Continue to UBO Identification
        </button>
      </div>
    </div>
  );
};

export default StepRegistryData;
